import { render, staticRenderFns } from "./DailyResult.vue?vue&type=template&id=613bbe3a&scoped=true&"
import script from "./DailyResult.vue?vue&type=script&lang=js&"
export * from "./DailyResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613bbe3a",
  null
  
)

export default component.exports